<div class="row">
  <section>
    <div class="col-md-8">
      <div class="mwstext section">
        <div class="row">
          <div class="col-xs-3 col-sm-2 col-md-2 text-center mrgn-tp-md">
            <span
              class="glyphicon glyphicon-warning-sign glyphicon-error"
            ></span>
          </div>
          <div class="col-xs-9 col-sm-10 col-md-10">
            <h2 class="mrgn-tp-md">{{ 'notFound.title' | translate }}</h2>
            <p class="pagetag">
              <strong>{{ 'notFound.code' | translate }}</strong>
            </p>
          </div>
        </div>
        <div class='row'>
          <div class='col-md-12 col-sm-12'>
            <p>{{ 'notFound.description' | translate }}</p>
          </div>
        </div>
        <div class='row'>
          <div class='col-md-4 col-sm-4'>
            <carm-button
              *ngIf="((isLoggedIn$ | async) === false)"
              [btnTypeDefault]="true"
              [btnTypePrimary]="true"
              [btnStretch]="true"
              btnLabel="{{ 'notFound.homepage' | translate }}"
              (click)="navigateToHomepage()"
            ></carm-button>
            <carm-button
              *ngIf="(isLoggedIn$ | async ) && !isOrphan"
              [btnTypeDefault]="true"
              [btnTypePrimary]="true"
              [btnStretch]="true"
              btnLabel="{{ 'notFound.dashboard' | translate }}"
              (click)="navigateToDashboard()"
            ></carm-button>
            <carm-button
              *ngIf="(isLoggedIn$ | async ) && isOrphan && !firstTimeSetupRoute"
              [btnTypeDefault]="true"
              [btnTypePrimary]="true"
              [btnStretch]="true"
              btnLabel="{{ 'notFound.dashboard' | translate }}"
              (click)="navigateToRegistrationDashboard()"
            ></carm-button>
            <carm-button
              *ngIf="(isLoggedIn$ | async ) && isOrphan && firstTimeSetupRoute"
              [btnTypeDefault]="true"
              [btnTypePrimary]="true"
              [btnStretch]="true"
              btnLabel="{{ 'notFound.firstTimeSetup' | translate }}"
              (click)="navigateToFirstSetup()"
            ></carm-button>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
